import { FC } from 'react';

import { CartProvider } from '@app/shop/context/CartContext';
import useCart from '@app/shop/hooks/useCart';
import { AlertItem } from '@app/shop/hooks/useAlerts';
import { AlertTitle, AlertType } from '@app/shop/components/Alert';
import Alerts from '@app/shop/components/Alerts';

const CartErrors: FC = () => {
  const { errors, userErrors } = useCart();
  return (
    <CartProvider>
      <Alerts
        alerts={[
          ...(errors?.length
            ? errors.map(
                (error): AlertItem => ({
                  type: error ? AlertType.Error : AlertType.Success,
                  content: <AlertTitle>{error.message}</AlertTitle>,
                })
              )
            : []),
          ...(userErrors?.length
            ? userErrors.map(
                (error): AlertItem => ({
                  type: error ? AlertType.Error : AlertType.Success,
                  content: (
                    <AlertTitle>
                      {error.message} (code: {error.code})
                    </AlertTitle>
                  ),
                })
              )
            : []),
        ]}
      />
    </CartProvider>
  );
};

export default CartErrors;
